function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#95afe7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#b8caef",
  transform: "rotate(45,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#d3ddf5",
  transform: "rotate(90,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#eaeffa",
  transform: "rotate(135,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#f3f6fc",
  transform: "rotate(180,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#f3f6fc",
  transform: "rotate(225,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#f3f6fc",
  transform: "rotate(270,64,64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#f3f6fc",
  transform: "rotate(315,64,64)"
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  values: "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64",
  calcMode: "discrete",
  dur: "720ms",
  repeatCount: "indefinite"
}));

function SvgIcnSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {},
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSpinner);
export default __webpack_public_path__ + "static/media/icn_spinner.e40a5043.svg";
export { ForwardRef as ReactComponent };